import type { PayrollRegisterResponse } from '../../reports/types';
import { formatMoney } from '../formatting';

/** Renders the Reports payroll register exactly as the server returned it — every figure and every total is
 * the server's; nothing is computed here. */
export function PayrollRegisterTable({ register }: { register: PayrollRegisterResponse }) {
  const { totals, lines } = register;
  return (
    <div className="payroll-review__table-scroll" role="region" aria-label="Payroll register by employee" tabIndex={0}>
      <table className="payroll-review__register">
        <caption className="payroll-review__sr-only">Payroll register — per-employee figures and run totals</caption>
        <thead>
          <tr>
            <th scope="col">Employee</th>
            <th scope="col" className="num">Gross earnings</th>
            <th scope="col" className="num">Employee taxes</th>
            <th scope="col" className="num">Employer taxes</th>
            <th scope="col" className="num">Pre-tax deductions</th>
            <th scope="col" className="num">Post-tax deductions</th>
            <th scope="col" className="num">Garnishments</th>
            <th scope="col" className="num">Net pay</th>
          </tr>
        </thead>
        <tbody>
          {lines.map((line) => (
            <tr key={line.employeeId}>
              <th scope="row">
                {line.employeeNumber} — {line.employeeName}
              </th>
              <td className="num">{formatMoney(line.grossEarnings)}</td>
              <td className="num">{formatMoney(line.employeeTaxes)}</td>
              <td className="num">{formatMoney(line.employerTaxes)}</td>
              <td className="num">{formatMoney(line.preTaxDeductionsTotal)}</td>
              <td className="num">{formatMoney(line.postTaxDeductionsTotal)}</td>
              <td className="num">{formatMoney(line.garnishmentsTotal)}</td>
              <td className="num">{formatMoney(line.netPay)}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <th scope="row">Totals</th>
            <td className="num">{formatMoney(totals.grossEarnings)}</td>
            <td className="num">{formatMoney(totals.employeeTaxes)}</td>
            <td className="num">{formatMoney(totals.employerTaxes)}</td>
            <td className="num">{formatMoney(totals.preTaxDeductionsTotal)}</td>
            <td className="num">{formatMoney(totals.postTaxDeductionsTotal)}</td>
            <td className="num">{formatMoney(totals.garnishmentsTotal)}</td>
            <td className="num">{formatMoney(totals.netPay)}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}
